import RequestAbstract from "./RequestAbstract";
import helper from "actions/helper";

export default class RepeatedVisits extends RequestAbstract {
    get link() {
        return this.links.repeatedVisits;
    }

    async getRepeatedVisits(id) {
        const arr = [
            { field: "clientId", op: "=", value: +id },
        ];

        return this.getAllFiltered([arr]);
    }

    async getRepeatedVisitsFuture(domainId, from, to) {
        const arr = [
            { field: "targetDate", op: ">=", value: helper.date.toStr(from) },
            { field: "targetDate", op: "<=", value: helper.date.toStr(to) },
            /*{ field: "domainId", op: "=", value: domainId },*/
            { field: "status", op: "!=", value: "TASK_COMPLETED" },
        ];

        return this.getAllFiltered([arr]);
    }
}
